import { Injectable } from '@angular/core';

import { BetSlipType } from '@bpos';

import { BetslipType } from '../../../../../core/betslip-type';
import { isBetBuilderPick } from '../../../../../core/utils';
import { CriteriaType, IRewardToken } from '../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../criteria-validator-base.service';

@Injectable()
export class SlipTypeValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.SlipType;
    isValid(token: IRewardToken, state: TokenValidationInput): boolean {
        const picks = state.selectedPicks;
        const currentSelectedType = state.selectedType;

        //the not bet builder condition below is added because the slip type check will be included part of BetBuilderValidator in case there are any bet builder picks
        if (token.filter?.betSlipType && !picks.some((pick) => isBetBuilderPick(pick)) && state.selectedType !== BetslipType.BetBuilder) {
            switch (token.filter.betSlipType) {
                case BetSlipType.Single: {
                    return currentSelectedType === BetslipType.Single;
                }
                case BetSlipType.Combo: {
                    return currentSelectedType === BetslipType.Combo || currentSelectedType === BetslipType.Teaser;
                }
                case BetSlipType.System: {
                    return currentSelectedType === BetslipType.System;
                }
            }
        }

        return true;
    }
}
